<template>
  <div class="JsonEditor">
    <div ref="editor"></div>
  </div>
</template>

<script>
import { JSONEditor } from 'vanilla-jsoneditor'

export default {
  name: 'PlainJsonEditor',
  model: { prop: 'value', event: 'input' },
  props: { value: { required: true } },
  data() {
    return {
      editor: undefined,
      currentState: undefined,
      cursorPosition: undefined
    }
  },

  computed: {
    content() {
      if (typeof this.value === 'string') return { text: this.value }
      if (this.value && typeof this.value === 'object') {
        return { text: JSON.stringify(this.value, null, 2) }
      }

      return { text: '' }
    },
    valueIsEmpty() {
      if (!this.currentState) return false
      try {
        const obj = JSON.parse(this.currentState.text)
        return Object.keys(obj).length === 0
      } catch (error) {
        return false
      }
    }
  },

  watch: {
    // when parent (v-model) changes the value, update the editor text
    value(newVal) {
      if (!this.editor) return
      const text =
        typeof newVal === 'string'
          ? newVal
          : JSON.stringify(newVal || {}, null, 2)
      this.editor.update({ text })
    },
    valueIsEmpty(val) {
      this.$emit('value-is-empty', val)
    }
  },

  mounted() {
    this.refreshEditor()
  },

  methods: {
    refreshEditor() {
      if (!this.currentState) this.currentState = this.content
      this.updateEditor(this.currentState)
    },
    updateEditor(content) {
      if (this.editor) this.editor.update(content)
      else this.createEditor(content)
    },
    createEditor(content) {
      this.editor = new JSONEditor({
        target: this.$refs.editor,
        props: {
          content,
          mode: 'text',
          mainMenuBar: false,
          navigationBar: false,
          onChange: updatedContent => {
            this.$emit('input', updatedContent.text)

            const isContentEdited =
              !this.currentState ||
              this.currentState.text !== updatedContent.text
            this.currentState = updatedContent

            this.$nextTick(() => {
              this.$emit('validation-result', this.editor.validate() === null)
              this.$emit('value-edited', isContentEdited)
            })
          },
          onSelect: selection => {
            this.cursorPosition = selection.ranges[0].head
          }
        }
      })
    },
    clear() {
      if (this.editor) {
        this.editor.destroy()
        this.editor = undefined
        this.currentState = undefined
      }
    },
    validate() {
      return this.editor.validate()
    },
    getPayload() {
      return this.currentState && this.validate() === null
        ? this.currentState.text
        : undefined
    }
  }
}
</script>

<style scoped>
.JsonEditor-Buttons {
  display: flex;
  justify-content: end;
  position: absolute;
  z-index: 1;
  right: 10px;
  top: 10px;
}
.dropdown-btn {
  padding: 8px;
  width: 35px;
  height: 35px;
  background-color: #fff;
}
.btn-group {
  display: flex;
}
.actions {
  position: absolute;
  z-index: 99;
  right: 0;
}
>>> .el-textarea__inner {
  padding-top: 31px !important;
  height: 120px;
  font-family: sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/common/components/PlainJsonEditor.vue